export const COSMOS_DEFAULT_LANDING_ROUTE = '/organizations/$orgCode';
export const COSMOS_DEFAULT_IOT_HUB_DEVICES_ROUTE =
	'/organizations/$orgCode/iot-hub/devices/list';
export const COSMOS_DEFAULT_CCTV_CAMERAS_ROUTE =
	'/organizations/$orgCode/cctv-hub/cameras/list';
export const COSMOS_DEFAULT_PROJECT_OVERVIEW_ROUTE =
	'/organizations/$orgCode/projects/$projectCode/workbenches/dashboard';
export const COSMOS_DEFAULT_WORKBENCH_OVERVIEW_ROUTE =
	'/organizations/$orgCode/projects/$projectCode/workbenches/$workbenchId/dashboard';
export const COSMOS_DEFAULT_ONBOARDING_ROUTE = '/onboarding';
export const COSMOS_DEFAULT_PAGES_ROUTE = '/pages';
export const COSMOS_DEFAULT_DOWNLOAD_APP_ROUTE = '/pages/download-app';

export const COSMOS_DEFAULT_PROJECTS_VIEW = 'map';
export const COSMOS_DEFAULT_PROJECTS_ROUTE_PREFIX = `/organizations/$orgCode/projects`;
export const COSMOS_DEFAULT_PROJECTS_ROUTE = `${COSMOS_DEFAULT_PROJECTS_ROUTE_PREFIX}/${COSMOS_DEFAULT_PROJECTS_VIEW}`;

export const COSMOS_ALLOW_MOBILE_VIEW_ROUTES = [
	COSMOS_DEFAULT_DOWNLOAD_APP_ROUTE,
];
export const COSMOS_PUBLIC_ROUTES = [
	COSMOS_DEFAULT_ONBOARDING_ROUTE,
	COSMOS_DEFAULT_PAGES_ROUTE,
];

export const WEBVIEW_CREATE_FORM_ROUTE =
	'/organizations/$orgCode/projects/$projectCode/workbenches/$workbenchId/$appId/form/create';
export const WEBVIEW_FILL_FORM_ROUTE =
	'/organizations/$orgCode/projects/$projectCode/workbenches/$workbenchId/$appId/form/$formId';
export const COSMOS_ALLOW_WEBVIEW_ROUTES = [
	WEBVIEW_CREATE_FORM_ROUTE,
	WEBVIEW_FILL_FORM_ROUTE,
];
